module.exports = __webpack_public_path__ + "static/media/icon-up.de29d597.svg";